import '@availity/yup';
import * as yup from 'yup';

const COMMA_SEPARATED_VALUES_REGEXP =
  /^[a-zA-Z\u00C0-\u017F0-9\s'\-./]+(?:(?:,)[a-zA-Z\u00C0-\u017F0-9\s'\-./]+)*[a-zA-Z\u00C0-\u017F0-9\s'\-./]+$/g;

const formValidation = yup.object().shape({
  name: yup.string().required(),
  customerId: yup.string().required(),
  startDate: yup.date().required(),
  endDate: yup.date().required(), //.min(yup.ref('startDate')),
  priority: yup.number().required().positive(),
  leads: yup.number().required().integer(),
  payout: yup.number().required().min(0),
  percentageRebate: yup.number().required().min(0),
  /*messageTemplateId: yup
    .string()
    .required()
    .when('sendLeadType', {
      is: 'trackingPixel',
      then: () => yup.string().matches(/^(?!.*none).*$/),
    }),*/
  messageTemplateId: yup.string().required(),
  messageSendDelay: yup.number().when('messageTemplateId', {
    is: (value) => value && value !== 'none',
    then: () => yup.number().required().min(0),
  }),
  sendLeadType: yup.string().required(),
  landingPageCustomer: yup.string().when('sendLeadType', {
    is: (value) => value === 'dataEntry' || value === 'trackingPixel',
    then: () => yup.string().required(),
  }),
  trackingMessageTemplateId: yup.string().when('sendLeadType', {
    is: 'trackingPixel',
    then: () => yup.string().required(),
  }),
  webService: yup.string().when('sendLeadType', {
    is: 'webService',
    then: () => yup.string().required(),
  }),
  spreadsheetLeadFieldIds: yup.array().when('sendLeadType', {
    is: 'googleSpreadsheets',
    then: () => yup.array().required().min(3),
  }),
  costPositiveClosure: yup.number().required().min(0),
  validLeads: yup.number().min(0),
  reasons: yup.string().matches(COMMA_SEPARATED_VALUES_REGEXP, {
    excludeEmptyString: true,
  }),
  supplierId: yup.string(),
  percentageRevenueShare: yup.number().when('supplierId', {
    is: (value) => !!value,
    then: () => yup.number().min(0).required(),
  }),
  percentageMarginShare: yup.number().when('supplierId', {
    is: (value) => !!value,
    then: () => yup.number().min(0).required(),
  }),
  sendSchedule: yup
    .object()
    .shape({
      enabled: yup.boolean(),
      matrix: yup.object(),
    })
    .test(
      'non-negative-integers',
      'Schedule values must be integers >= 0',
      function (value) {
        const scheduleSupportedSendLeadTypes = [
          'webService',
          'googleSpreadsheets',
        ];
        const sendLeadType = this.parent?.sendLeadType;
        const isScheduleRelevant =
          scheduleSupportedSendLeadTypes.includes(sendLeadType);

        if (!isScheduleRelevant || !value?.enabled) return true;

        const cells = Object.values(value.matrix || {}).flatMap((row) =>
          Object.values(row || {}),
        );

        if (cells.length === 0) return false;

        return cells.every((v) => {
          if (v === '' || v === null || typeof v === 'undefined') {
            return false;
          }
          const numericValue = Number(v);
          return Number.isInteger(numericValue) && numericValue >= 0;
        });
      },
    ),
});

export default formValidation;
